// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  name: __t.string(),
  rating: __t.i32(),
  stake: __t.u32(),
  mode: __t.string(),
  room: __t.string(),
  boostEnabled: __t.bool().name("boost_enabled"),
  joinedAtMicros: __t.u64().name("joined_at_micros"),
  botFallbackAtMicros: __t.option(__t.u64()).name("bot_fallback_at_micros"),
  accountId: __t.string().name("account_id"),
  balanceKind: __t.string().name("balance_kind"),
});
